export enum EStockAnalyticType {
    TOTAL = 'total',
    AVAILABLE = 'available',
    SOLD = 'sold',
    RESERVED = 'reserved',
    OUTOFSTOCK = 'outOfStock'
}